/**
 * DisplayControl.js - Remote control Android displays via scrcpy web interface
 */

import React, { useState } from 'react';

const DisplayControl = ({ displays }) => {
  const [selectedDisplay, setSelectedDisplay] = useState(null);
  // Use proxy to bypass X-Frame-Options restrictions for iframe
  // IMPORTANT: trailing slash ensures relative URLs in scrcpy resolve correctly
  const scrcpyProxyUrl = '/api/video-sync/scrcpy-proxy/';
  const scrcpyDirectUrl = 'http://172.16.7.2:8000';

  const handleSelectDisplay = (display) => {
    setSelectedDisplay(display);
  };

  return (
    <div className="display-control">
      {displays.length === 0 ? (
        <div className="empty-state">
          <h2>Display Control</h2>
          <p>No displays available. Please add displays first.</p>
        </div>
      ) : (
        <div className="control-layout">
          {/* Left Column: Header + Display Selection */}
          <div className="left-column">
            <div className="control-header">
              <h2>Display Control</h2>
              <p className="subtitle">Remote control Android displays with full touch and visual sync</p>
            </div>
            <div className="display-selector">
              <h3>Select Display</h3>
            <div className="display-list">
              {displays.map((display) => (
                <button
                  key={display._id}
                  className={`display-item ${selectedDisplay?._id === display._id ? 'active' : ''}`}
                  onClick={() => handleSelectDisplay(display)}
                >
                  <div className="display-icon">📺</div>
                  <div className="display-info">
                    <div className="display-name">{display.name}</div>
                    <div className="display-ip">{display.ipAddress}</div>
                    <div className={`status-indicator ${display.online ? 'online' : 'offline'}`}>
                      {display.online ? '● Online' : '● Offline'}
                    </div>
                  </div>
                </button>
              ))}
            </div>

            <div className="scrcpy-info">
              <h4>About scrcpy</h4>
              <p>Full remote control with:</p>
              <ul>
                <li>Real-time screen mirroring</li>
                <li>Touch control</li>
                <li>Keyboard input</li>
                <li>Low latency streaming</li>
              </ul>
              <p className="note">
                Note: Display must be connected via ADB to enable control.
              </p>
            </div>
            </div>
          </div>

          {/* scrcpy Web Interface */}
          <div className="scrcpy-container">
            {selectedDisplay ? (
              <div className="scrcpy-wrapper">
                <div className="scrcpy-header">
                  <h3>Controlling: {selectedDisplay.name}</h3>
                  <div className="scrcpy-actions">
                    <a
                      href={scrcpyDirectUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-secondary"
                    >
                      Open in New Tab
                    </a>
                    <button
                      className="btn-primary"
                      onClick={() => window.location.reload()}
                    >
                      Refresh
                    </button>
                  </div>
                </div>

                <iframe
                  src={scrcpyProxyUrl}
                  title="scrcpy Web Control"
                  className="scrcpy-iframe"
                  allow="fullscreen; autoplay; camera; microphone; display-capture"
                />

                <div className="control-instructions">
                  <h4>Instructions:</h4>
                  <ol>
                    <li>Click on the device in the scrcpy interface: <strong>{selectedDisplay.ipAddress}:5555</strong></li>
                    <li>Wait for the screen to connect and stream</li>
                    <li>Click and drag to control the display</li>
                    <li>Use keyboard to type on the display</li>
                  </ol>
                </div>
              </div>
            ) : (
              <div className="no-selection">
                <div className="empty-icon">📱</div>
                <h3>No Display Selected</h3>
                <p>Select a display from the left sidebar to begin remote control</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DisplayControl;
